import React from 'react';
import {observer} from 'mobx-react';
import {TimesheetEditor} from 'main/containers/time_tracking/components/timesheet_editor';
import {withState} from 'shared/core';
import {auth} from 'main/tools';
import {Layout} from 'shared/components';
import MyTimesheetState from '../state/MyTimesheetState';
import _ from 'lodash';

const MyTimesheetContainer = observer(({uiState}) => {
  const {sortedPayPeriods, selectedPayPeriod} = uiState;

  if (_.isEmpty(sortedPayPeriods)) return null;

  return (
    <div>
      <Layout>
        <TimesheetEditor
          payPeriods={sortedPayPeriods}
          employee={auth.employee}
          payPeriod={selectedPayPeriod}
          onPayPeriodSelected={(payPeriod) => uiState.selectPayPeriod(payPeriod)}
          myTimesheet
        />
      </Layout>
    </div>
  );
});

export default withState(MyTimesheetContainer, MyTimesheetState);
